<template>
  <v-container fluid class="down-top-padding">
    <v-row>
      <v-col cols="12" lg="12">
        <v-card>
          <v-toolbar flat>
            <v-col cols="12" class="px-0">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    JO Created
                  </v-toolbar-title>
                </div>
                <div class="ml-auto">
                  <v-dialog
                    ref="dialog"
                    v-model="modal"
                    :return-value.sync="dates"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="primary" v-bind="attrs" v-on="on">
                        <v-icon class="mr-2">mdi-calendar</v-icon> Choose Dates
                      </v-btn>
                    </template>
                    <v-date-picker v-model="dates" :max="currentDate">
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="modal = false">
                        Cancel
                      </v-btn>
                      <v-btn text color="primary" @click="onSelectDate(dates)">
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                  <v-btn color="primary"  class="ml-2" @click="exportData()">
                    <v-icon class="mr-2">mdi-download</v-icon> Export
                  </v-btn>
                </div>
              </div>
            </v-col>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-divider></v-divider>

          <!-- <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title> -->
          <v-data-table
            :page="table.page"
            :pageCount="table.numberOfPages"
            :options.sync="options"
            :server-items-length="table.total"
            :headers="table.headers"
            :items="table.data"
            :items-per-page="10"
            :loading="table.loading"
            item-key="_id"
            loading-text="Loading... Please wait"
            class="elevation-1"
            :footer-props="{
              'items-per-page-options': [10, 20, 50, 100],
            }"
          >
            <template
              v-for="header in table.headers.filter((header) =>
                header.hasOwnProperty('formatter')
              )"
              v-slot:[`item.${header.value}`]="{ value }"
            >
              {{ header.formatter(value) }}
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <Snackbar></Snackbar>
  </v-container>
</template>

<script>
import moment from "moment";
import Snackbar from "../dialogs/Snackbar.vue";
export default {
  components: {
    Snackbar,
  },
  data() {
    return {
      modal: false,
      search: "",
      dates: moment().format("YYYY-MM-DD"),
      currentDate: moment().format("YYYY-MM-DD"),
      table: {
        page: 0,
        total: 0,
        numberOfPages: 0,
        // sortBy: "dtCreated",
        // sortDesc: true,
        loading: false,
        headers: [
          {
            text: "Reference Number",
            align: "start",
            sortable: false,
            value: "referenceNumber",
          },
          {
            text: "Subscriber Name",
            align: "start",
            value: "subscriberName",
          },
          {
            text: "JO Created",
            align: "start",
            sortable: false,
            value: "joCreatedDate",
            formatter: (x) =>
              x ? moment(x).format("MMM. DD, YYYY hh:mm:ss A") : null,
          },
          {
            text: "Payment Date",
            align: "start",
            sortable: false,
            value: "paymentDate",
            formatter: (x) =>
              x ? moment(x).format("MMM. DD, YYYY hh:mm:ss A") : null,
          },
          {
            text: "Activation Date",
            align: "start",
            sortable: false,
            value: "activationDate",
            formatter: (x) =>
              x ? moment(x).format("MMM. DD, YYYY hh:mm:ss A") : null,
          },

          {
            text: "Payment Method",
            align: "start",
            sortable: false,
            value: "paymentMethod",
          },

          {
            text: "Distributor",
            align: "start",
            sortable: false,
            value: "distributorName",
          },
          {
            text: "Status",
            align: "start",
            value: "status",
          },
        ],
        data: [],
      },

      options: {
        page: 1,
      },
    };
  },
  // props: ["tableAPIUrl", "reload", "headers"],

  methods: {
    onSelectDate(e) {
      this.$refs.dialog.save(e)
      console.log("asdadasda", e);
      // this.dates = e;
      this.modal = false;
    
      console.log(e, this.dates);
      this.getList();
    },

    async getList() {
      this.table.loading = true;
      console.log(this.dates);
      const { page, itemsPerPage } = this.options;
      let pageNumber = "";
      if (itemsPerPage === -1) {
        pageNumber = "";
      } else {
        pageNumber = page ? page : 1;
      }

      const perPage = itemsPerPage < 0 ? "" : itemsPerPage;

      await this.$api
        .get(
          `/dashboard-jo-created?page=${pageNumber}&limit=${perPage}&date=${this.dates}`
        )
        .then((response) => {
          // console.log(response);
          const newArr = response.data.data;
          this.table.total = newArr.total;
          this.table.numberOfPages = Math.ceil(newArr.total / itemsPerPage);
          this.table.data = newArr.list;
          this.table.loading = false;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },
  },
  created() {
    // this.getList();
    // console.log(this.$props.headers);
  },

  mounted() {
    this.getList();
  },

  watch: {
    options: {
      handler() {
        this.getList();
      },
      deep: true,
    },
  },

  computed: {
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },
};
</script>
